import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import demo0 from "../../assets/images/demo/1447_b.jpeg";

import OrderConstant from "../../constants/OrderConstant";

import {
  getStorageList as getStorageListAction,
  getStorageListByCat as getStorageListByCatAction,
  addStorage as addStorageAction,
  update as updateStorageAction,
  search as searchAction,
} from "../../redux/modules/storage";

import { convertImages, fromArrayListKey, inArrayValueByKey } from "../../utilities/array";

import UiInputSearch from "../../components/inputs/UiInputSearch";
import UiButtonColor from "../../components/button/UiButtonColor";
import UiModalProductAdd from "../../components/modals/UiModalProductAdd";
import UiPageText from "../../components/text/UiPageText";
import UiTableAdaptive from "../../components/table/UiTableAdaptive";

import "./ProductsStyle.scss";
import Env from "../../services/Env";
import { storeData } from "../../services/Storage";

function ProductsPage(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modalDealAddACtive, setModalDealAddActive] = useState(false);
  const [searchLine, setSearchLine] = useState(null);

  const [page, setPage] = useState(1);
  const [maxPages, setMaxPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const clientsTitles = [
    { sort: false, title: "" },
    { sort: false, title: "" },
    { sort: true, title: "Номер" },
    { sort: false, title: "Название" },
    { sort: false, title: "Описание" },
    { sort: false, title: "Метка" },
    { sort: true, title: "Категория" },
    { sort: true, title: "Цена" },
    { sort: false, title: "Скрыть" },
    { sort: false, title: "Удалить" },
  ];
  const [tableListOrders, setTableListOrders] = useState([]);

  function _load(_page = 1) {
    if (id == "all") props.getStorageList(); else props.getStorageListByCat(id, _page);
  }

  function search(line){
    if(line.length > 0) props.search(line); else _load();
  }

  useEffect(() => {
    _load();
  }, [id]);

  useEffect(() => {
    let arr = [];
    props.storage.list.map((item) => {
      let images = convertImages(item.imgs);
      item.images = images;
      arr.push([
        {
          button: "edit", onClick: () => {
            storeData("edit", item)
            navigate("/products/add");
          }
        },
        { image: images[0] ? Env.PUBLIC_URL + images[0] : null },
        { text: item.article },
        { text: item.title },
        { text: item.text },
        { text: item.tags },
        { 
          statusInfo: props.category.list.length > 0 ? 
          inArrayValueByKey( props.category.list , 'id' , item.category )?.title : "", 
          statusColor: "orange" 
        },
        { text: `${item.price} ₽` },
        {
          button: item.is_active == 0 ? "eye-open" : "eye", onClick: () => {
            let _item = item;
            _item.is_active = item.is_active == 1 ? 0 : 1;
            props.update(_item).then(() =>  _load() );
          }
        },
        {
          button: "delete", onClick: () => {
            let _item = item;
            _item.is_del = 1 ;
            props.update(_item).then(() =>  _load() );
          }
        },

      ])
    })

    if(props.storage.list[0]){ 
      if(props.storage.list[0].total_page_count){
        setMaxPage(props.storage.list[0].total_page_count)
        setTotalCount(props.storage.list[0].total_count)
      }
      
    } 
    setTableListOrders(arr);
  }, [props.storage.list, props.category.list]);
  

  return (
    <div id="page" className="home-page">
      <section className="home-info ui-grid">
        <div className="home-info-text">
          <UiPageText title={`Список товаров в категории: ${props.category.list.length > 0 ? 
          inArrayValueByKey( props.category.list , 'id' , id )?.title : ""} ( ${totalCount > 0   ? totalCount : props.category.list.length }шт )`} />
        </div>
        <div className="home-info-button">
          <UiButtonColor
            color="primary"
            text="Добавить"
            small={true}
            onClick={() => {
              storeData("edit", null);
              navigate("/products/add");
            }}
          />
        </div>
      </section>
      <section className="page-content">
        <div className="page-search">
          <UiInputSearch 
            placeholder="Поиск по всем категориям:"
            onChange={(val) => search(val)}
          />
        </div>

        <UiTableAdaptive
          currentPage={page}
          pageCount={maxPages}
          pageSize={50}

          onChangePage={(_page) => {  
            setPage(_page+1);
            _load(_page+1);
          }}
          titleList={clientsTitles}
          grid={clientsTitles.length}
          tableList={tableListOrders} 
        />
      </section>
      {/* modal deal add */}
      <UiModalProductAdd
        modalActive={modalDealAddACtive}
        modalClose={() => setModalDealAddActive(false)}
        findUserEvent={props.getUsersByPhone}
        prices={props.settings.prices}
        onCreate={(data) => {
          props.addOrder(data).then(() => {
            setModalDealAddActive(false);
          });
        }}
      />
    </div>
  );
}

export default connect(
  ({ storage, login, comment, logs, user, settings, category }) => ({
    storage,
    login,
    comment,
    logs,
    user,
    settings,
    category
  }),
  {
    getStorageList: getStorageListAction,
    getStorageListByCat: getStorageListByCatAction,
    addStorage: addStorageAction,
    update: updateStorageAction,
    search: searchAction,

  }
)(ProductsPage);
